<template>
  <Table :sendFlag="2" TableName="TABLE_RECEIVE_INFO" permissionName="RECEIVE_INFO"/>
</template>

<script lang='ts'>

import { defineComponent } from 'vue'
import Table from '../components/Table.vue'

export default defineComponent({
  name: 'Receive',
  components: {
    Table
  }

})
</script>
